import axios from "axios";

import { apiConfig } from "../config/authConfig";
import { CredentialManager } from "../classes/credentialManager";
import { IContainer } from "../types/container";

export namespace ContainerService {
	const credentialManager = CredentialManager.getInstance();

	/**********
	 * Convert one api response object to one Container.
	 * @param data Container response data from an API.
	 **********/
	export function mapContainer(data: any) {
		const container: IContainer = {
			id: data.id.toString(),
			name: data.name,
			weight: data.weight,
			isActive: data.isActive,
			length: data.length,
			width: data.width,
			height: data.height,
			fillsPosition: data.fillsPosition,
			externalName: data.externalName
		}

		return container;
	}

	/**********
	 * Convert an array of api response objects to an array of Containers.
	 * @param data Container data from an API response.
	 **********/
	export function mapContainers(data: any) {
		let containers: IContainer[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any) => {
				containers.push(mapContainer(item));
			})
		}

		return containers;
	}

	/**********
	 * Gets all containers.
	 **********/
	export async function getContainers() {
		const apiResponse = axios.get(
			apiConfig.default + "/container/all",
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`
				},
			}
		)

		return apiResponse;
	}

	/**********
	 * Gets a container by its ID.
	 **********/
	export async function getContainer(id: string) {
		const apiResponse = axios.get(
			apiConfig.default + "/container/" + id,
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`
				},
			}
		)

		return apiResponse;
	}

	/**********
	 * Add a new container starting with details.
	 * @param details The container's details.
	 **********/
	export async function addContainer(details: IContainer) {
		const apiResponse = axios.post(
			apiConfig.default + "/container",
			details,
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`
				},
			}
		)

		return apiResponse;
	}

	/**********
	 * Update a container's details.
	 **********/
	export async function updateContainer(details: IContainer) {
		const apiResponse = axios.put(
			apiConfig.default + "/container",
			details,
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`
				},
			}
		)

		return apiResponse;
	}

	/**********
	 * Activates an inactive container by its ID.
	 * @param containerId The ID of the inactive container to activate.
	 **********/
	export async function activateContainer(containerId: number) {
		const apiResponse = axios.put(
			apiConfig.default + "/container/" + containerId + "/activate",
			{},
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`
				},
			}
		)

		return apiResponse;
	}

	/**********
	 * Deactivates an active container by its ID.
	 * @param containerId The ID of the active container to deactivate.
	 **********/
	export async function deactivateContainer(containerId: number) {
		const apiResponse = axios.put(
			apiConfig.default + "/container/" + containerId + "/deactivate",
			{},
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`
				},
			}
		)

		return apiResponse;
	}
}
